import React from "react";
import {createNativeStackNavigator} from "@react-navigation/native-stack";
import {ParamListBase} from "@react-navigation/native";
import FallOutManageScreen from "./screens/manage/fallOutManageScreen";
import FallOutListScreen from "./screens/list/fallOutListScreen";

const Stack = createNativeStackNavigator<FallOutStackParamList>();

export default function SystemUsersStack() {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name='list'
        component={FallOutListScreen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name='manage'
        component={FallOutManageScreen}
        options={{headerShown: false}}
      />
    </Stack.Navigator>
  );
};

export const fallOutsLinkingOptions = {
  path: 'fall-out',
  screens: {
    list: 'list',
    manage: 'manage'
  },
}

export type FallOutStackParamList = ParamListBase & {
  list: undefined;
  manage: {id: string};
};
